// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_1u8zeW","heroLogo":"_2bpTkf","heroTitle":"_14g7kD","titleChronicle":"GcvZnJ","heroSubtitle":"_378fJA","heroImage":"_3xYZLw"};